var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgSpaceInvader(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 118.89,
    height: 140,
    viewBox: "0 0 118.89 140",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "space-invader") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    points: "36.5 41.63 26.2 35.68 26.2 23.79 36.5 29.73 36.5 41.63",
    fill: "#6e6f72"
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "46.8 47.57 36.5 41.63 36.5 29.73 46.8 35.68 46.8 47.57",
    fill: "#6e6f72"
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "57.1 53.52 46.8 47.57 46.8 35.68 57.1 41.63 57.1 53.52",
    fill: "#6e6f72"
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "67.4 59.46 57.1 53.52 57.1 41.63 67.4 47.57 67.4 59.46",
    fill: "#6e6f72"
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "77.7 65.41 67.4 59.46 67.4 47.57 77.7 53.52 77.7 65.41",
    fill: "#6e6f72"
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "57.1 65.41 46.8 59.46 46.8 47.57 57.1 53.52 57.1 65.41",
    fill: "#6e6f72"
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "67.4 71.36 57.1 65.41 57.1 53.52 67.4 59.46 67.4 71.36",
    fill: "#6e6f72"
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "77.7 77.3 67.4 71.36 67.4 59.46 77.7 65.41 77.7 77.3",
    fill: "#6e6f72"
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "88 71.36 77.7 65.41 77.7 53.52 88 59.46 88 71.36",
    fill: "#6e6f72"
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "46.8 35.68 36.5 29.73 36.5 17.84 46.8 23.79 46.8 35.68",
    fill: "#6e6f72"
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "88 59.46 77.7 53.52 77.7 41.63 88 47.57 88 59.46",
    fill: "#6e6f72"
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "98.3 77.3 88 71.36 88 59.46 98.3 65.41 98.3 77.3",
    fill: "#6e6f72"
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "36.5 65.41 26.2 59.46 26.2 47.57 36.5 53.52 36.5 65.41",
    fill: "#6e6f72"
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "46.8 71.36 36.5 65.41 36.5 53.52 46.8 59.46 46.8 71.36",
    fill: "#6e6f72"
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "57.1 77.3 46.8 71.36 46.8 59.46 57.1 65.41 57.1 77.3",
    fill: "#6e6f72"
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "67.4 83.25 57.1 77.3 57.1 65.41 67.4 71.36 67.4 83.25",
    fill: "#6e6f72"
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "77.7 89.2 67.4 83.25 67.4 71.36 77.7 77.3 77.7 89.2",
    fill: "#6e6f72"
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "88 95.14 77.7 89.2 77.7 77.3 88 83.25 88 95.14",
    fill: "#6e6f72"
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "98.3 101.09 88 95.14 88 83.25 98.3 89.2 98.3 101.09",
    fill: "#6e6f72"
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "36.5 77.3 26.2 71.36 26.2 59.46 36.5 65.41 36.5 77.3",
    fill: "#6e6f72"
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "46.8 83.25 36.5 77.3 36.5 65.41 46.8 71.36 46.8 83.25",
    fill: "#6e6f72"
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "57.1 89.2 46.8 83.25 46.8 71.36 57.1 77.3 57.1 89.2",
    fill: "#6e6f72"
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "67.4 95.14 57.1 89.2 57.1 77.3 67.4 83.25 67.4 95.14",
    fill: "#6e6f72"
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "77.7 101.09 67.4 95.14 67.4 83.25 77.7 89.2 77.7 101.09",
    fill: "#6e6f72"
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "88 107.03 77.7 101.09 77.7 89.2 88 95.14 88 107.03",
    fill: "#6e6f72"
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "46.8 107.03 36.5 101.09 36.5 89.2 46.8 95.14 46.8 107.03",
    fill: "#6e6f72"
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "57.1 112.98 46.8 107.03 46.8 95.14 57.1 101.09 57.1 112.98",
    fill: "#6e6f72"
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "77.7 124.87 67.4 118.93 67.4 107.03 77.7 112.98 77.7 124.87",
    fill: "#6e6f72"
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "88 130.82 77.7 124.87 77.7 112.98 88 118.93 88 130.82",
    fill: "#6e6f72"
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "98.3 112.98 88 107.03 88 95.14 98.3 101.09 98.3 112.98",
    fill: "#6e6f72"
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "36.5 89.2 26.2 83.25 26.2 71.36 36.5 77.3 36.5 89.2",
    fill: "#6e6f72"
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "98.3 124.87 88 118.93 88 107.03 98.3 112.98 98.3 124.87",
    fill: "#6e6f72"
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "108.59 107.03 98.3 101.09 98.3 89.2 108.59 95.14 108.59 107.03",
    fill: "#6e6f72"
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "118.89 112.98 108.59 107.03 108.59 95.14 118.89 101.09 118.89 112.98",
    fill: "#6e6f72"
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "36.5 53.52 26.2 47.57 26.2 35.68 36.5 41.63 36.5 53.52",
    fill: "#6e6f72"
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "26.2 47.57 15.9 41.63 15.9 29.73 26.2 35.68 26.2 47.57",
    fill: "#6e6f72"
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "26.2 59.46 15.9 53.52 15.9 41.63 26.2 47.57 26.2 59.46",
    fill: "#6e6f72"
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "15.9 53.52 5.6 47.57 5.6 35.68 15.9 41.63 15.9 53.52",
    fill: "#6e6f72"
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "118.89 124.87 108.59 118.93 108.59 107.03 118.89 112.98 118.89 124.87",
    fill: "#6e6f72"
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "15.9 65.41 5.6 59.46 5.6 47.57 15.9 53.52 15.9 65.41",
    fill: "#6e6f72"
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "118.89 136.77 108.59 130.82 108.59 118.93 118.89 124.87 118.89 136.77",
    fill: "#6e6f72"
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "15.9 77.3 5.6 71.36 5.6 59.46 15.9 65.41 15.9 77.3",
    fill: "#6e6f72"
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "98.3 89.2 88 83.25 88 71.36 98.3 77.3 98.3 89.2",
    fill: "#6e6f72"
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "108.59 95.14 98.3 89.2 98.3 77.3 108.59 83.25 108.59 95.14",
    fill: "#6e6f72"
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "36.5 17.84 26.2 11.89 26.2 0 36.5 5.95 36.5 17.84",
    fill: "#6e6f72"
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "98.3 53.52 88 47.57 88 35.68 98.3 41.63 98.3 53.52",
    fill: "#6e6f72"
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "20.6 27.02 26.2 23.79 36.5 29.73 30.9 32.97 20.6 27.02",
    fill: "#6e6f72"
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "10.3 32.97 15.9 29.73 26.2 35.68 20.6 38.91 10.3 32.97",
    fill: "#6e6f72"
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "0 38.91 5.6 35.68 15.9 41.63 10.3 44.86 0 38.91",
    fill: "#6e6f72"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    points: "30.9 44.86 20.6 38.91 20.6 27.02 30.9 32.97 30.9 44.86",
    fill: "#7fc347"
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "41.2 50.8 30.9 44.86 30.9 32.97 41.2 38.91 41.2 50.8",
    fill: "#7fc347"
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "51.5 56.75 41.2 50.8 41.2 38.91 51.5 44.86 51.5 56.75",
    fill: "#7fc347"
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "61.8 62.7 51.5 56.75 51.5 44.86 61.8 50.8 61.8 62.7",
    fill: "#7fc347"
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "72.1 68.64 61.8 62.7 61.8 50.8 72.1 56.75 72.1 68.64",
    fill: "#7fc347"
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "51.5 68.64 41.2 62.7 41.2 50.8 51.5 56.75 51.5 68.64",
    fill: "#7fc347"
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "61.8 74.59 51.5 68.64 51.5 56.75 61.8 62.7 61.8 74.59",
    fill: "#7fc347"
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "72.1 80.54 61.8 74.59 61.8 62.7 72.1 68.64 72.1 80.54",
    fill: "#7fc347"
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "82.4 74.59 72.1 68.64 72.1 56.75 82.4 62.7 82.4 74.59",
    fill: "#7fc347"
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "41.2 38.91 30.9 32.97 30.9 21.07 41.2 27.02 41.2 38.91",
    fill: "#7fc347"
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "82.4 62.7 72.1 56.75 72.1 44.86 82.4 50.8 82.4 62.7",
    fill: "#7fc347"
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "92.69 80.54 82.4 74.59 82.4 62.7 92.69 68.64 92.69 80.54",
    fill: "#7fc347"
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "30.9 68.64 20.6 62.7 20.6 50.8 30.9 56.75 30.9 68.64",
    fill: "#7fc347"
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "41.2 74.59 30.9 68.64 30.9 56.75 41.2 62.7 41.2 74.59",
    fill: "#7fc347"
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "51.5 80.54 41.2 74.59 41.2 62.7 51.5 68.64 51.5 80.54",
    fill: "#7fc347"
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "61.8 86.48 51.5 80.54 51.5 68.64 61.8 74.59 61.8 86.48",
    fill: "#7fc347"
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "72.1 92.43 61.8 86.48 61.8 74.59 72.1 80.54 72.1 92.43",
    fill: "#7fc347"
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "82.4 98.38 72.1 92.43 72.1 80.54 82.4 86.48 82.4 98.38",
    fill: "#7fc347"
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "92.69 104.32 82.4 98.38 82.4 86.48 92.69 92.43 92.69 104.32",
    fill: "#7fc347"
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "30.9 80.54 20.6 74.59 20.6 62.7 30.9 68.64 30.9 80.54",
    fill: "#7fc347"
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "41.2 86.48 30.9 80.54 30.9 68.64 41.2 74.59 41.2 86.48",
    fill: "#7fc347"
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "51.5 92.43 41.2 86.48 41.2 74.59 51.5 80.54 51.5 92.43",
    fill: "#7fc347"
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "61.8 98.38 51.5 92.43 51.5 80.54 61.8 86.48 61.8 98.38",
    fill: "#7fc347"
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "72.1 104.32 61.8 98.38 61.8 86.48 72.1 92.43 72.1 104.32",
    fill: "#7fc347"
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "82.4 110.27 72.1 104.32 72.1 92.43 82.4 98.38 82.4 110.27",
    fill: "#7fc347"
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "41.2 110.27 30.9 104.32 30.9 92.43 41.2 98.38 41.2 110.27",
    fill: "#7fc347"
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "51.5 116.21 41.2 110.27 41.2 98.38 51.5 104.32 51.5 116.21",
    fill: "#7fc347"
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "72.1 128.11 61.8 122.16 61.8 110.27 72.1 116.21 72.1 128.11",
    fill: "#7fc347"
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "82.4 134.05 72.1 128.11 72.1 116.21 82.4 122.16 82.4 134.05",
    fill: "#7fc347"
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "92.69 116.21 82.4 110.27 82.4 98.38 92.69 104.32 92.69 116.21",
    fill: "#7fc347"
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "30.9 92.43 20.6 86.48 20.6 74.59 30.9 80.54 30.9 92.43",
    fill: "#7fc347"
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "92.69 128.11 82.4 122.16 82.4 110.27 92.69 116.21 92.69 128.11",
    fill: "#7fc347"
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "103 110.27 92.69 104.32 92.69 92.43 103 98.38 103 110.27",
    fill: "#7fc347"
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "113.29 116.22 103 110.27 103 98.38 113.29 104.32 113.29 116.22",
    fill: "#7fc347"
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "30.9 56.75 20.6 50.8 20.6 38.91 30.9 44.86 30.9 56.75",
    fill: "#7fc347"
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "20.6 50.8 10.3 44.86 10.3 32.97 20.6 38.91 20.6 50.8",
    fill: "#7fc347"
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "20.6 62.7 10.3 56.75 10.3 44.86 20.6 50.8 20.6 62.7",
    fill: "#7fc347"
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "10.3 56.75 0 50.8 0 38.91 10.3 44.86 10.3 56.75",
    fill: "#7fc347"
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "113.29 128.11 103 122.16 103 110.27 113.29 116.22 113.29 128.11",
    fill: "#7fc347"
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "10.3 68.64 0 62.7 0 50.8 10.3 56.75 10.3 68.64",
    fill: "#7fc347"
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "113.29 140 103 134.05 103 122.16 113.29 128.11 113.29 140",
    fill: "#7fc347"
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "10.3 80.54 0 74.59 0 62.7 10.3 68.64 10.3 80.54",
    fill: "#7fc347"
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "92.69 92.43 82.4 86.48 82.4 74.59 92.69 80.54 92.69 92.43",
    fill: "#7fc347"
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "103 98.38 92.69 92.43 92.69 80.54 103 86.48 103 98.38",
    fill: "#7fc347"
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "30.9 21.07 20.6 15.13 20.6 3.23 30.9 9.18 30.9 21.07",
    fill: "#7fc347"
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "92.69 56.75 82.4 50.8 82.4 38.91 92.69 44.86 92.69 56.75",
    fill: "#7fc347"
  })), /*#__PURE__*/React.createElement("polygon", {
    points: "20.6 3.23 26.2 0 36.5 5.95 30.9 9.18 20.6 3.23",
    fill: "#6e6f72"
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "30.9 21.07 36.5 17.84 46.8 23.79 41.2 27.02 30.9 21.07",
    fill: "#6e6f72"
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "10.3 56.75 10.3 80.54 15.9 77.3 15.9 59.98 10.3 56.75",
    fill: "#818285"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M30.9,44.86V56.75l5.6-3.23V48.09Z",
    fill: "#818285"
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "46.8 23.79 41.2 27.02 41.2 38.91 46.8 35.68 46.8 23.79",
    fill: "#818285"
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "98.3 41.63 92.69 44.86 92.69 56.75 98.3 53.52 98.3 41.63",
    fill: "#818285"
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "88 54.04 88 59.46 82.4 62.7 82.4 50.8 88 54.04",
    fill: "#818285"
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "98.3 65.41 92.69 68.64 92.69 80.54 98.3 77.3 98.3 65.41",
    fill: "#818285"
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "108.59 83.25 103 86.48 103 98.38 108.59 95.14 108.59 83.25",
    fill: "#818285"
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "118.89 101.09 113.29 104.32 113.29 140 118.89 136.77 118.89 101.09",
    fill: "#818285"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M92.7,128.11l5.6-3.23V107.56s-5.6-3.71-5.6-3.23v23.79Z",
    fill: "#818285"
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "88 130.82 82.4 134.05 82.4 122.16 88 125.39 88 130.82",
    fill: "#818285"
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "51.5 116.21 57.1 112.98 57.1 101.09 51.5 104.32 51.5 116.21",
    fill: "#818285"
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "30.9 92.43 36.5 89.2 36.5 83.51 30.9 80.54 30.9 92.43",
    fill: "#818285"
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "77.7 77.3 72.1 80.54 72.1 68.64 77.7 71.88 77.7 77.3",
    fill: "#818285"
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "30.9 9.18 36.5 5.95 36.5 17.84 30.9 21.07 30.9 9.18",
    fill: "#818285"
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "30.9 92.43 36.5 89.2 57.1 101.09 51.5 104.32 30.9 92.43",
    fill: "#6e6f72"
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "67.4 107.03 61.8 110.27 82.4 122.16 82.4 115.69 67.4 107.03",
    fill: "#6e6f72"
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "88 35.68 82.4 38.91 92.69 44.86 98.3 41.63 88 35.68",
    fill: "#6e6f72"
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "82.4 44.34 82.4 50.8 72.1 44.86 77.7 41.63 82.4 44.34",
    fill: "#6e6f72"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSpaceInvader);
export default __webpack_public_path__ + "static/media/space-invader.5af31c485f6636c3a0b5998e449ecb39.svg";
export { ForwardRef as ReactComponent };